/**
 * Quarter Config Master Data Interfaces
 * Framework-agnostic TypeScript interfaces for Quarter configuration management
 */

export interface Quarter {
  id: number;
  quarter_name: string;
  start_date: string;
  end_date: string;
  program_id: number;
  status: number;
  created_at?: string;
  updated_at?: string;
}

export interface QuarterFormData {
  quarter_name: string;
  start_date: string;
  end_date: string;
  program_id: number;
  id?: number;
}

export interface QuarterApiResponse {
  status: number;
  data: Quarter[];
  body?: {
    data: {
      message?: string;
    };
  };
}

export interface QuarterStatusPayload {
  id: number;
  status: number;
}
